import React, { useState, createContext, useContext } from 'react'

const initScannerContextPropsState = {
  pass: undefined,
  setPass: () => { },
  results: [],
  setResults: () => { },
  openModal: false,
  setOpenModal: () => { },
}

const ScannerContext = createContext(initScannerContextPropsState)

const useScanner = () => {
  return useContext(ScannerContext)
}

const ScannerProvider = ({ children }) => {
  const [pass, setPass] = useState(undefined)
  const [results, setResults] = useState([])
  const [openModal, setOpenModal] = useState(false)

  return (
    <ScannerContext.Provider
      value={{ pass, setPass, results, setResults, openModal, setOpenModal }}
    >
      {children}
    </ScannerContext.Provider>
  )
}

export { ScannerProvider, useScanner }
